<script setup lang="ts">
definePageMeta({
  title: 'Wire-Splicing',
  description: 'New standards of wire-splicing with TECH-SONIC\'s ultrasonic closed-loop control.',
  order: 2,
})
</script>

<template>
  <section>
    <BlockContent>
      <h1 class="mb-4 uppercase font-flex-100-151-640">
        Wire-Splicing
      </h1>
      <h2 class="subpage-title">
        Set a New Standard with Ultrasonic Wire-Splicing
      </h2>
      <h3 class="subpage-subtitle mt-2">
        ICS & TECH-SONIC take welding to the next level
      </h3>
      <div class="my-10 gap-x-4 gap-y-8 grid grid-cols-1 md:grid-cols-2">
        <div>
          <div class="text-lg max-w-prose space-y-4">
            <p>
              Our US-3620WN2 ultrasonic wire splicer is known for creating top-quality welds with strong, clean, and highly conductive bonds.
            </p>
            <p>
              Ultrasonic welding ensures our customers get the highest-quality welds and precise control over the process. And less energy consumption means lower cost all-around.
            </p>
            <p>
              The ultrasonic wire splicer offers a wide range of weld capabilities, accommodating cross-section sizes from 0.5 mm² to 34 mm².
            </p>
            <ul class="text-base px-4 list-disc">
              <li>Pure metallurgical bonds for non-ferrous materials</li>
              <li>Weld dissimilar materials</li>
              <li>Fast cycle times and consistent weld quality</li>
            </ul>
          </div>
          <nav class="my-10 flex flex-wrap gap-6">
            <AButton
              label="Get a Quote"
              to="/contact/rfq"
              color="blue"
            />
            <AButton
              label="The TECH-SONIC US-3620WN2"
              to="https://tech-sonic.us/us-3620wn2-ultrasonic-wire-splicer/"
              color="gray"
              material="empty"
              new-tab
            />
          </nav>
          <NuxtLink
            to="https://tech-sonic.us/"
            class="group py-4 flex-inline gap-3 items-center"
          >
            <NuxtImg
              src="fe025736-a596-4d05-b44f-77963a3df914"
              alt="The TECH-SONIC logo."
              class="w-18"
            />
            <div class="i-carbon-launch transition-colors group-hover:bg-icssilver-800 dark:group-hover:bg-icssilver-200" />
          </NuxtLink>
        </div>
        <NuxtImg
          class="w-full transition-opacity object-cover dark:opacity-80"
          src="9bdf58fb-cdf5-4e94-a69e-72402812f8ec"
          alt="The TECH-SONIC US-3620WN2 ultrasonic wire splicer isolated on a transparent background."
        />
      </div>

      <!-- <ACard element="aside">
        <template #header>
          <h6 class="text-xl font-flex-400">
            Ultrasonic vs. Pneumatic Welding
          </h6>
          <hr class="my-4 b-icsgray">
        </template>
        Put some light educational content here for SEO.
      </ACard> -->
    </BlockContent>
  </section>
</template>
